angular.module('impactx.list').controller('ItemExpansionCtrl', [
    'dataGen',
    '$timeout',
    ItemExpansionCtrl
]);

function ItemExpansionCtrl(dataGen, $timeout) {
    var ctrl = this;
    ctrl.done = false;

    $timeout(function() {
        ctrl.templateUrl = ctrl.getTemplateUrl(ctrl.row);
        ctrl.entryPoint = ctrl.getEntryPoint(ctrl.row);
        ctrl.params = ctrl.getParams(ctrl.row);
        if (ctrl.templateUrl && ctrl.entryPoint && ctrl.params) {
            dataGen.getData({}, ctrl.params, ctrl.entryPoint).then(function (result) {
                if (result && result.data) {
                    ctrl.data = result.data;
                    ctrl.trns = result.trns;
                    ctrl.done = true;
                }
            });
        }
    });
}